import React, { useState } from "react";
import { Flex, Form, DatePicker, Button } from "antd";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";
import { FilterOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

function FilterMenu(props) {
  var currentDate = new Date().toISOString().split("T")[0];

  const [filterForm] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [startDate, setStartDate] = useState(searchParams.get("strDate") ?? currentDate);
  const [endDate, setEndDate] = useState(searchParams.get("endDate") ?? currentDate);

  const onSetDate = () => {
    setSearchParams({
      ...Object.fromEntries(searchParams.entries()),
      strDate: startDate,
      endDate: endDate,
    });

    props.onQueryDate({ strDate: startDate, endDate: endDate });
  };

  return (
    <Form
      form={filterForm}
      layout="vertical"
      onFinishFailed={() => console.log("Error")}
    >
      <Flex justify="space-between" gap="small">
        <Flex gap="small">
          {/* <Form.Item
            label="Start Date"
            name="startDate"
            style={{ fontWeight: 600 }}
          >
            <DatePicker
              format="DD-MM-YYYY"
              allowClear={false}
              defaultValue={dayjs(startDate)}
              value={dayjs(startDate)}
              onChange={(e) => {
                setStartDate(e ? dayjs(e).format("YYYY-MM-DD") : "");
              }}
            />
          </Form.Item>
          <Form.Item
            label="End Date"
            name="endDate"
            style={{ fontWeight: 600 }}
          >
            <DatePicker
              format="DD-MM-YYYY"
              allowClear={false}
              defaultValue={dayjs(endDate)}
              value={dayjs(endDate)}
              onChange={(e) => {
                setEndDate(e ? dayjs(e).format("YYYY-MM-DD") : "");
              }}
            />
          </Form.Item> */}
          <Form.Item
            label="Start & End Date"
            name="range"
            style={{ fontWeight: 600 }}
          >
            <RangePicker
              format="DD-MM-YYYY"
              allowClear={false}
              defaultValue={[dayjs(startDate), dayjs(endDate)]}
              onChange={(e) => {
                setStartDate(e ? dayjs(e[0]).format("YYYY-MM-DD") : "");
                setEndDate(e ? dayjs(e[1]).format("YYYY-MM-DD") : "");
              }}
            />
          </Form.Item>
          <Form.Item
            label={<span style={{ color: "#FFF", fontWeight: 600 }}>text</span>}
            name="text"
            labelCol={{ color: "#FFF" }}
          >
            <Button
              type="primary"
              icon={<FilterOutlined />}
              onClick={onSetDate}
            >
              Filter
            </Button>
          </Form.Item>
        </Flex>
      </Flex>
    </Form>
  );
}

export default FilterMenu;
